import { render, staticRenderFns } from "./ShipmentDetailsBlock.vue?vue&type=template&id=c4598bf0&scoped=true"
import script from "./ShipmentDetailsBlock.vue?vue&type=script&lang=js"
export * from "./ShipmentDetailsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4598bf0",
  null
  
)

export default component.exports